import { AnyQuestionI } from "services/shortAnswerService/question-types/Question";
import { isCalculationQuestion } from "services/shortAnswerService/question-types/typeGuards";

import { FLAGGING_RATE_HIGHER_THRESHOLD } from "./consts";
import {
  FlatSectionWithQuestion,
  getOneQuestionFromEachSectionOnCondition,
  groupQuestionBySection,
  questionHasAutoMarking,
  removeDuplicateQuestions
} from "./general";

export function getQuestionModelAccuracy(question: AnyQuestionI) {
  if (isCalculationQuestion(question)) {
    return 1;
  }

  const { modelAccuracy, autoMarkType } = question;
  if (modelAccuracy) return modelAccuracy;

  switch (autoMarkType) {
    case "none":
      return 0;
    case "distance":
      return 0.9;
    default:
      return 0.7;
  }
}

export function sortFlatSectionWithQuestionOnAccuracyCB(
  a: FlatSectionWithQuestion,
  b: FlatSectionWithQuestion
) {
  return (
    getQuestionModelAccuracy(b.question) - getQuestionModelAccuracy(a.question)
  );
}

export function sortFlatSectionWithQuestionByFlaggingRate(
  a: FlatSectionWithQuestion,
  b: FlatSectionWithQuestion
) {
  if (
    questionHasAutoMarking(a.question) &&
    !questionHasAutoMarking(b.question)
  ) {
    return -1;
  }

  if (
    !questionHasAutoMarking(a.question) &&
    questionHasAutoMarking(b.question)
  ) {
    return 1;
  }

  if (
    !questionHasAutoMarking(a.question) &&
    !questionHasAutoMarking(b.question)
  ) {
    return 0;
  }

  if (
    a.question.flaggingRate === undefined &&
    b.question.flaggingRate !== undefined
  ) {
    return FLAGGING_RATE_HIGHER_THRESHOLD - b.question.flaggingRate;
  }

  if (
    b.question.flaggingRate === undefined &&
    a.question.flaggingRate !== undefined
  ) {
    return a.question.flaggingRate - FLAGGING_RATE_HIGHER_THRESHOLD;
  }

  return (a.question.flaggingRate ?? 0) - (b.question.flaggingRate ?? 0);
}

export function getMostAccurateQuestions(
  questionsWithSectionId: FlatSectionWithQuestion[],
  numberOfQuestions: number
) {
  const sortedByAccuracy = questionsWithSectionId.sort(
    sortFlatSectionWithQuestionOnAccuracyCB
  );

  const firstQuestions = getOneQuestionFromEachSectionOnCondition(
    sortedByAccuracy,
    () => true
  );

  const allQuestions = removeDuplicateQuestions([
    ...firstQuestions,
    ...sortedByAccuracy
  ]).slice(0, numberOfQuestions);

  return groupQuestionBySection(allQuestions);
}
